<script setup>
import { onMounted, ref } from 'vue';
import lottie from 'lottie-web';

const animationContainer = ref(null);

onMounted(() => {
  // Load lottie animation
  lottie.loadAnimation({
    container: animationContainer.value,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/animations/Sending_paperplane.json', // place animation locally
  });
});
</script>

<template>
  <div class="loader-overlay">
    <div ref="animationContainer" style="width: 400px; height: 400px"></div>
  </div>
</template>

<style>
.loader-overlay {
  position: fixed;
  inset: 0;

  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 9999;

  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
